<template>
  <div class="story text-light flex-column">
    <div class="background bg-1">
      <img :src="require(`@/assets/capas/nossa-historia.webp`)">
    </div>
    <header>
      <div class="title title-1">Nossa História</div>
      <div class="body-2">Conheça mais sobre o Grupo Topázio</div>
    </header>
    <div class="content">
      <div class="img-story gradient" v-show="windowWidth > 1110">
        <div>
          <img :src="require(`@/assets/story/story-1.png`)">
        </div>
      </div>
      <div class="img-story gradient" v-show="windowWidth > 1110">
        <div>
          <img :src="require(`@/assets/story/story-2.png`)">
        </div>
      </div>
      <div class="img-story story-bottom gradient" v-show="windowWidth > 900">
        <div>
          <img :src="require(`@/assets/story/story-3.png`)">
        </div>
      </div>
      <div class="line" v-if="apiEvents.length > 0">
        <div class="time-line flex-column">
          <!-- timeline - primeiros 7 eventos -->
          <TimeLineItem
            v-for="(event, index) in leftColumnEvents"
            :key="'left-' + index"
            :date="formatDate(event.eventDate)"
            :scroll="String(52 + (index * 120))"
          >
            <span v-html="event.description"></span>
          </TimeLineItem>
        </div>
        <div class="line-b">
          <!-- timeline bottom - eventos 8, 9, 10 (desktop) -->
          <div class="time-line-b flex">
            <TimeLineItem
              v-for="(event, index) in bottomRowEvents"
              :key="'bottom-' + index"
              :date="formatDate(event.eventDate)"
              :scroll="String(892 + (index * 140))"
              v-show="index === 0 || (index === 1 && windowWidth > 786) || (index === 2 && windowWidth > 1005)"
            >
              <span v-html="event.description"></span>
            </TimeLineItem>
          </div>

          <!-- timeline right -->
          <div class="time-line-l flex-column">
            <!-- Eventos 9 e 10 aparecem aqui no mobile -->
            <TimeLineItem
              v-if="bottomRowEvents[1]"
              v-show="windowWidth < 787"
              :date="formatDate(bottomRowEvents[1].eventDate)"
              scroll="1050"
            >
              <span v-html="bottomRowEvents[1].description"></span>
            </TimeLineItem>
            <TimeLineItem
              v-if="bottomRowEvents[2]"
              v-show="windowWidth < 1006"
              :date="formatDate(bottomRowEvents[2].eventDate)"
              scroll="1199"
            >
              <span v-html="bottomRowEvents[2].description"></span>
            </TimeLineItem>
            <!-- Eventos da coluna direita -->
            <TimeLineItem
              v-for="(event, index) in rightColumnEvents"
              :key="'right-' + index"
              :date="formatDate(event.eventDate)"
              :scroll="String(1299 + (index * 100))"
            >
              <span v-html="event.description"></span>
            </TimeLineItem>
          </div>
        </div>
      </div>
    </div>
    <div class="subtitle-6 text-primary"><i>"Até aqui nos ajudou o Senhor!"</i></div>
  </div>
</template>

<script>
import TimeLineItem from '@/components/TimeLineItem'
import api from '@/services/api'

export default {
  name: 'OurStory',
  components: {
    TimeLineItem
  },
  data () {
    return {
      scrollY: window.scrollY,
      windowWidth: window.innerWidth,
      // Dados da API
      apiEvents: []
    }
  },
  async created () {
    await this.fetchTimeline()
  },
  computed: {
    // Primeiros 7 eventos - coluna esquerda
    leftColumnEvents () {
      return this.apiEvents.slice(0, 7)
    },
    // Eventos 8, 9, 10 - linha inferior
    bottomRowEvents () {
      return this.apiEvents.slice(7, 10)
    },
    // Restante dos eventos - coluna direita
    rightColumnEvents () {
      return this.apiEvents.slice(10)
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  },
  methods: {
    async fetchTimeline () {
      try {
        const data = await api.getTimeline()
        if (data && data.events) {
          this.apiEvents = data.events
        }
      } catch (error) {
        console.error('Erro ao carregar timeline:', error)
        // Mantém array vazio se API falhar
        this.apiEvents = []
      }
    },
    formatDate (dateString) {
      if (!dateString) return ''
      // Parse manual para evitar problema de timezone
      const parts = dateString.split('-')
      if (parts.length === 3) {
        const day = parts[2].substring(0, 2) // pega só os 2 primeiros chars (ignora hora se tiver)
        const month = parts[1]
        const year = parts[0]
        return `${day}/${month}/${year}`
      }
      return dateString
    }
  }
}
</script>

<style lang="scss" scoped>
.story {
  justify-content: start;
  position: relative;
}
.story header{
  padding: 40px 80px;
  margin-top: 50px;
  margin-bottom: 16vw;
  text-align: left;
}
@media screen and (max-width: 425px){
  .story header{
    padding: 40px 40px;
  }
  #content {
    margin: 0 0;
  }
}
.story .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: -1;
  width: 120vw;
  min-height: 430px;
  max-height: 430px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
  img {
    transform: rotate(3.5deg);
    width: 90%;
    margin-left: 25px;
    margin-top: -90px;
  }
}
@media screen and (max-width: 930px) {
  .story .background {
    img {
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 730px) {
  .story .background {
    img {
      margin-top: 80px;
    }
  }
}
@media screen and (max-width: 575px) {
  .story .background {
    img {
      width: 120%;
      min-width: 664px;
      margin-left: -30px;
      margin-top: 100px;
    }
  }
}
.story .subtitle-6 {
  text-align: left;
  margin: 10px 0 0 80px;
}
@media screen and (min-width: 900px){
  .story .subtitle-6 {
    margin: -200px 0 0 140px;
  }
}
@media screen and (max-width: 530px){
  .story .subtitle-6 {
    margin: 10px auto 0 auto;
  }
}
.story .content {
  position: relative;
  max-width: 1424px;
  margin: 0 auto 0 auto;
  .img-story {
    position: absolute;
    width: 35vw;
    max-width: 495px;
    height: 18vw;
    max-height: 283px;
    right: -20px;
    top: 100px;
    div {
      width: 100%;
      height: 100%;
      background: url("../assets/logos/logo-icon.png") no-repeat center;
      background-size: 70px;
      img {
        width: 103%;
        margin-left: -3%;
      }
    }
  }
  .img-story:nth-child(2) {
    top: 450px;
  }
  .story-bottom {
    width: 45vw;
    max-width: 664px;
    height: 25vw;
    max-height: 369px;
    top: 1100px !important;
    left: 0;
  }
}
.line, .line-b {
  width: 80vw;
  max-width: 1080px;
}
.line {
  margin: 20px auto 1050px auto;
  height: 850px;
  border-radius: 0 0 0 12px;
  border-left: solid 1px #005245;
  border-bottom: solid 1px #005245;
  position: relative;
  .time-line {
    text-align: left;
    color: #3e3e3e;
    position: absolute;
    top: -6px;
    gap: 50px;
    margin-left: -6px;
  }
  .line-b {
    position: absolute;
    bottom: -1201px;
    right: -10px;
    height: 1200px;
    border-right: solid 1px #005245;
    border-top: solid 1px #005245;
    border-radius: 0 12px 0 0;
    .time-line-b {
      text-align: left;
      color: #3e3e3e;
      position: absolute;
      top: -6px;
      gap: 20px;
    }
    .time-line-l {
      text-align: right;
      color: #3e3e3e;
      position: absolute;
      top: 160px;
      right: 0;
      gap: 50px;
      margin-right: -6px;
    }
  }
}
</style>